import { render, staticRenderFns } from "./AnswerPhoneText.vue?vue&type=template&id=5044b801"
import script from "./AnswerPhoneText.vue?vue&type=script&lang=js"
export * from "./AnswerPhoneText.vue?vue&type=script&lang=js"
import style0 from "./AnswerPhoneText.vue?vue&type=style&index=0&id=5044b801&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports